import { DownOutlined } from '@ant-design/icons';
import { Button, Col, ConfigProvider, Dropdown, Image, MenuProps, Row, Space } from 'antd';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Routes } from '../../../../app/routes';
import logo from '../../../../assets/logo.svg';
import { useGetUserQuery } from '../../../../modules/user/api/user-api';
import { toggleDrawerMenu } from '../../../../modules/ui/store/ui-slice';
import InitialsIcon from '../../../../shared/components/buttons/initials-icon/initials-icon';
import HamburgerButton from '../../../../shared/components/hamburger-button/hamburger-button';
import { useBreakpoint } from '../../../../shared/hooks/use-breakpoint';
import styles from './header.module.css';

interface Props {
  actionButton?: ReactNode;
}

const Header = ({ actionButton }: Props): JSX.Element => {
  const { t } = useTranslation('common');
  const screens = useBreakpoint();
  const dispatch = useDispatch();

  const { data: currentUser } = useGetUserQuery();

  const items: MenuProps['items'] = [
    {
      key: 'current-user-info',
      label: <Link to={Routes.UserDetails}>{t('header.currentUser')}</Link>,
    },
    {
      key: 'user-trace-logs',
      label: <Link to={Routes.UserTraceLogs}>{t('header.userTraceLogs')}</Link>,
    },
    {
      key: 'logout',
      label: <Link to={Routes.Logout}>{t('header.logout')}</Link>,
    },
  ];

  const menuProps = {
    items,
  };

  return (
    <header className={styles.innerLayoutHeader}>
      <Row gutter={[16, 8]} align="bottom" justify="space-between">
        {!screens.xl && (
          <Col>
            <HamburgerButton
              changeIcon={false}
              buttonProps={{
                onClick: () => dispatch(toggleDrawerMenu()),
              }}
              isOpened={true}
              isDisabled={false}
              extraMargin={false}
            />
          </Col>
        )}
        {screens.sm && (
          <Col>
            <Link to={Routes.Main}>
              <Image src={logo} alt={t('header.logo')} preview={false} />
            </Link>
          </Col>
        )}

        <Col flex="auto" />
        {actionButton && screens.sm && <Col className={styles.actionButton}>{actionButton}</Col>}
        <Col>
          {currentUser?.name && (
            <ConfigProvider
              theme={{
                token: {
                  controlHeight: 38,
                  colorBgContainer: '#F5F5F5',
                },
              }}
            >
              <Dropdown menu={menuProps}>
                <Button>
                  <Space>
                    <InitialsIcon fullName={currentUser.name || ''} />
                    {screens.md && <span className={styles.userName}>{currentUser.name}</span>}
                    <DownOutlined />
                  </Space>
                </Button>
              </Dropdown>
            </ConfigProvider>
          )}
        </Col>
      </Row>
    </header>
  );
};

export default Header;
